<template>
  <div v-if="$store.getters.storeInfo">
    <v-tooltip bottom :color="status ? 'success' : 'red'">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          v-bind="attrs"
          :color="status ? 'success' : 'error'"
          v-on="on"
          v-text="'mdi-checkbox-blank-circle'"
        />
        <b
          v-bind="attrs"
          class="pl-2"
          v-on="on"
          v-text="$t('adminGeneral.store_status')"
        />
      </template>
      <span
        v-text="status ? $t('adminGeneral.online') : $t('adminGeneral.offline')"
      />
    </v-tooltip>
    <v-btn large icon @click="status = !status">
      <v-icon
        :color="status ? 'success' : 'red'"
        v-text="status ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'"
      />
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "StoreStatusSwitch",
  computed: {
    status: {
      get() {
        return this.$store.getters.storeInfo.statusOnline ? 1 : 0;
      },
      set(val) {
        this.changeStatus(val ? 1 : 0);
      },
    },
  },
  methods: {
    changeStatus: async function (val) {
      const self = this;
      let form = new Form({
        status: val,
      });

      const { data } = await form.post(
        "/admin/store/" + self.$store.getters.storeIdAdmin + "/status"
      );
      Toast.fire({
        icon: "success",
        title: data.message,
      });
      self.$store.dispatch("storeInfo/loadStoreInfoAdmin");
    },
  },
};
</script>
